export default "__VITE_ASSET__CvMErcve__"